<template>
    <div class="add-new-client">
        <md-dialog :md-active.sync="showDialog" >         
          <md-dialog-title>
              <span>New Board for {{campaign.name}}</span>
              <button class="btn btn--close" @click="cancel"></button>
          </md-dialog-title>
             <validation-observer v-slot="{ handleSubmit }" tag="div">
              <form @submit.prevent="handleSubmit(addNewBoard)" class="form">
                <div class="form__content">                                            
                  <ValidationProvider :rules="{required :true, min:3}" v-slot="{ errors }" tag="div">
                    <md-field>                      
                      <label>Board name</label>
                      <md-input v-model="board.name" />
                    </md-field>
                    <div class="form__error">{{ errors[0] }}</div>
                  </ValidationProvider>                              
                </div>
                <md-dialog-actions>
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <md-button class="md-primary modal-cancel-btn" @click="cancel">Cancel</md-button>
                    </div>
                    <div class="md-layout-item text-right">
                    <md-button class="md-primary modal-save-btn" type="submit">Save Board</md-button>
                    </div>
                  </div>
                </md-dialog-actions>
            </form>
          </validation-observer>
        </md-dialog>
            
        <button class="btn btn-add-new-client-dash client-dashed" @click="showDialog = true">
            <img alt="Add Button" class="addButton" src="@/assets/img/icons/addButton.svg" />
            add new board
        </button>
    </div>
</template>


<script>
import apiHandlerMI from "@/mixins/apiHandlerMI.js";
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {min, required} from 'vee-validate/dist/rules';
import {setInteractionMode} from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "Board name is required."
});
extend('min', {
  ...min,
  message: "This field should contain at least 3 letters"
});

export default {
  props:['campaign'],
  mixins: [apiHandlerMI],
  data(){
    return{
      showDialog: false,
      active: false,
      board: {
        name: '',
        staus: 'live'
      },
      error: {},
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
    methods:{
      
      addNewBoard(){
        var _this = this;
        this.board.campaign_id = this.campaign.id;
        this.post('board',this.board,{},function(resp){
          //console.log(resp.data);                       
          _this.addUserToBoardNotify(resp.data.result.board)  
                 
        },function(resp){
          //console.log(resp);
          _this.error = resp.data.error;
          this.$forceUpdate();

        })
      },
      addUserToBoardNotify(board){
        let _this = this        

        this.post('user_to_board',
        {
          user_id: this.$store.state.user.id,
          board_id: board.id
        },
        {},function(){
          //console.log(resp.data);       
          _this.board = {
            name: '',
            status : 'live'            
          }; 
          _this.post('emailsender/4/1',{
              to: _this.$store.state.user.email,
              data_replace:{
                  name: _this.$store.state.user.name,
                  assigner_forname: _this.$store.state.user.name,              
                  board_slug: board.slug,
                  campaign: _this.campaign.name,
                  board: board.name
              }
          },{},function(){
            
          })
          if (_this.$parent.refreshBrand)
            _this.$parent.refreshBrand(() => {
              _this.$parent.selectBoard(board.id)
            });
            

          
          _this.showDialog = false
        },function(resp){
          console.log(resp);
          _this.error = resp.data.error;
          this.$forceUpdate();
        })

      },
      cancel(){
        this.showDialog = false
        
      }
    }
 }

</script>